import React, { useEffect, useState } from "react";
import SearchBar from "./components/SearchBar";
import WeatherCard from "./components/WeatherCard";
import ForecastCard from "./components/ForecastCard";
import History from "./components/History";
import { getHistory, getWeather, getForecast } from "./services/weatherService";
import "./App.css";

function App() {
  const [weather, setWeather] = useState(null);
  const [forecast, setForecast] = useState([]);
  const [history, setHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isDark, setIsDark] = useState(false);

  const loadHistory = async () => {
    try {
      const historyData = await getHistory();
      setHistory(historyData);
    } catch (err) {
      setError(err.message || "Unable to load search history");
    }
  };

  useEffect(() => {
    loadHistory();
  }, []);

  const handleSearch = async (city) => {
    if (!city.trim()) return;
    setIsLoading(true);
    setError("");
    try {
      const [data, forecastData] = await Promise.all([
        getWeather(city),
        getForecast(city),
      ]);
      setWeather(data);
      setForecast(forecastData);

      // Wait for Railway + MongoDB Atlas to finish saving before fetching history
      setTimeout(async () => {
        await loadHistory();
      }, 1500);

    } catch (err) {
      setError(err.message || "Unable to fetch weather");
      setWeather(null);
      setForecast([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleHistorySelect = (city) => {
    handleSearch(city);
  };

  return (
    <div className={`app-shell${isDark ? " theme-dark" : ""}`}>
      <div className="aurora aurora-left" />
      <div className="aurora aurora-right" />
      <main className="dashboard">
        <header className="dashboard-header">
          <div className="header-row">
            <p className="eyebrow">Live Conditions</p>
            <button
              className="theme-toggle"
              type="button"
              onClick={() => setIsDark((prev) => !prev)}
              aria-pressed={isDark}
            >
              {isDark ? "Light mode" : "Dark mode"}
            </button>
          </div>
          <h1>Weather Forecasting</h1>
          <p className="subtitle">
            Search any city to view real-time forecasts and track recent
            lookups.
          </p>
        </header>
        <section className="dashboard-content">
          <div className="left-panel">
            <SearchBar onSearch={handleSearch} isLoading={isLoading} />
            {error && <p className="error-message">{error}</p>}
            <WeatherCard data={weather} isLoading={isLoading} />
            <ForecastCard forecast={forecast} />
          </div>
          <aside className="right-panel">
            <History items={history} onSelect={handleHistorySelect} />
          </aside>
        </section>
      </main>
    </div>
  );
}

export default App;